module.exports = __webpack_public_path__ + "729e6a0d278376882d2b8409d6872474.woff";